import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import i18n from "./i18n";
import "@/style/common.scss";
import "./plugins/element.js";
import apiList from "@/api/apiList.js";
import actions from "@/store/shardActions";
import "./style/iconfont/iconfont.css";
import "./style/iconfont/iconfont";
import "@/style/element-ui.scss";
import "@/style/element-variables.scss";
Vue.config.productionTip = false;
Vue.prototype.$httpList = apiList;
Vue.prototype.$actions = actions;
Vue.prototype.$isProduction = process.env.NODE_ENV === "production";
import ElementLocale from "element-ui/lib/locale";

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
ElementLocale.i18n((key, value) => i18n.t(key, value));
